'use strict'

angular
  .module('basalteApp')
  .constant('BAS_SOUND', {
    DEFAULT_VOLUME: 0.75,
    RESOURCE_SOUND_PHOBOS: 'audio/phobos.mp3'
  })
